import { useEffect } from 'react';

import { areUserRolesIn } from '../../../../helpers';
import { Roles } from '../../../../constants';
import { fetchGuardianProviderAssignments } from '../services/general';

import type { UseGuardianProviderAssignmentsParams } from './types';

export const useGuardianProviderAssignments = ({
  sessionClientId,
  userRoles,
  isBay7InPersonGuardianFlow,
  getAccessTokenSilently,
  setGuardianProviderAssignments,
}: UseGuardianProviderAssignmentsParams) => {
  useEffect(() => {
    const normalizedUserRoles = userRoles ?? [];

    if (
      !sessionClientId ||
      !areUserRolesIn(normalizedUserRoles, [Roles.Vbt]) ||
      !isBay7InPersonGuardianFlow
    ) {
      return;
    }

    let cancelled = false;

    void (async () => {
      const guardianProviderAssignments = await fetchGuardianProviderAssignments(
        sessionClientId,
        getAccessTokenSilently,
      );

      if (!cancelled) {
        setGuardianProviderAssignments(guardianProviderAssignments);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    getAccessTokenSilently,
    isBay7InPersonGuardianFlow,
    sessionClientId,
    setGuardianProviderAssignments,
    userRoles,
  ]);
};
